VjsAdmin.VjsAdminAllLoginHistory = (function () {
    const $table = $('#allLoginhistory-table');

    const init = function () {
        initTable();
    };

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#allLoginhistory-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No users matching search term <strong>\`${SafeDOM.escapeHtml(searchTerm)}\`</strong>`;
            },
            idField: 'user_id',
            sortName: 'date_login',
            sortOrder: 'DESC',
            url: Slim.Router.pathFor('admin.user.loginhistory.list'),
            columns: [
                {
                    title: 'ID',
                    field: 'user_id',
                    align: 'left',
                    valign: 'middle',
                },
                {
                    title: 'Username',
                    field: 'username',
                    align: 'left',
                    valign: 'middle',
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'left',
                    valign: 'middle',
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'left',
                    valign: 'middle',
                },
                {
                    title: 'IP Address',
                    field: 'ip_address',
                    align: 'right',
                    valign: 'middle',
                },
                {
                    title: '<i class="fa fa-clock" aria-hidden="true"></i> Time Spent',
                    field: 'time_spent',
                    align: 'right',
                    valign: 'middle',
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Date Login',
                    field: 'date_login',
                    align: 'center',
                    valign: 'middle',
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    VjsAdmin.convertDateRow(result, 'MM/DD/YY');
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
